import { render, staticRenderFns } from "./TableTotal.vue?vue&type=template&id=1389477e&scoped=true&"
import script from "./TableTotal.vue?vue&type=script&lang=js&"
export * from "./TableTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1389477e",
  null
  
)

export default component.exports